module.exports = __webpack_public_path__ + "img/chrome-part.2552d32c.png";